import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { type AsChildProps, Slot } from "@/components/_molecules/slot.tsx";
import { useUpdateLabel } from "@/domain/label/hooks/api/use-update-label";

type UpdateLabelActionProps = AsChildProps<React.ButtonHTMLAttributes<HTMLButtonElement>> & {
  style?: React.CSSProperties;
  className?: string;
  label: {
    id: string;
    title: string;
    color: string;
  };
  onSuccess?: () => void;
  onError?: () => void;
};

export const UpdateLabelAction = ({ label, onSuccess, onError, asChild, ...props }: UpdateLabelActionProps) => {
  const { t } = useTranslation("common");
  const Comp = asChild ? Slot : "button";

  const { updateLabel } = useUpdateLabel({
    onCompleted: () => {
      toast.success(t("label.updateSuccess"), { description: t("label.updateSuccessDescription") });
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: () => {
      toast.error(t("errors.title"), { description: t("label.updateError") });
      if (onError) {
        onError();
      }
    },
  });

  async function handleClick() {
    await updateLabel({ id: label.id, title: label.title, color: label.color });
  }

  return <Comp {...props} onClick={handleClick} />;
};
